import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import CenteredContainer from '../centeredcontainer/CenteredContainer'
import Header from '../header/Header'
import Footer from '../footer/Footer'

export default function Signin() {

  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  async function handleSubmit(e) {
    e.preventDefault()
    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      history.push("/")
    } catch {
      setError("Failed to Sign in")
    }

    setLoading(false)
  }

  return (
    <div>
      <Header />
      <CenteredContainer>
        <Card>
          <Card.Body>
            <h2 className="text-center mb-4">تسجيل الدخول</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group id="email" className="mt-1">
                <Form.Label>البريد الإلكتروني</Form.Label>
                <Form.Control type="email" ref={emailRef} required />
              </Form.Group>
              <Form.Group id="password" className="mt-1">
                <Form.Label>كلمة المرور</Form.Label>
                <Form.Control type="password" ref={passwordRef} required />
              </Form.Group>
              <Button disabled={loading} className="w-100 mt-1" type="submit">
                تسجيل الدخول 
              </Button>
            </Form>
            <div className="w-100 text-center mt-3">
              <Link to="/forgotpassword">نسيت كلمة المرور</Link>
            </div>
          </Card.Body>
        </Card>
        <div className="w-100 text-center mt-2">
          تسجيل مستخدم جديد <Link to="/signup">التسجيل</Link>
        </div>
      </CenteredContainer>
      <Footer />
    </div>
  )
}
